import { render } from "./modal-iframe.html?vue&type=template&id=abf4faca&scoped=true&ts=true"
import script from "./modal-iframe.vue?vue&type=script&lang=ts"
export * from "./modal-iframe.vue?vue&type=script&lang=ts"

import "./modal-iframe.scss?vue&type=style&index=0&id=abf4faca&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf4faca"]])

export default __exports__